module.exports = __webpack_public_path__ + "img/20191028172241360截图20191028162925505.43e6ff25.jpg";